function routes($stateProvider) {
    $stateProvider
        .state('evaluation.learningGoals.subjectArea', {
            name: 'subjectArea',
            url: '/subject-area',
            views: {
                content: { template: '<subject-area></subject-area>' },
            },
        });
    $stateProvider
        .state('evaluation.learningGoals.defaultSubjectArea', {
            name: 'defaultSubjectArea',
            url: '/:subjectAreaId',
            views: {
                content: { template: '<other-tab></other-tab>' },
            },
        });
    $stateProvider
        .state('mini.learningGoals.subjectArea', {
            name: 'subjectArea',
            url: '/subject-area',
            views: {
                content: { template: '<subject-area></subject-area>' },
            },
        });
    $stateProvider
        .state('mini.learningGoals.defaultSubjectArea', {
            name: 'defaultSubjectArea',
            url: '/:subjectAreaId',
            views: {
                content: { template: '<other-tab></other-tab>' },
            },
        });
}

routes.$inject = [
    '$stateProvider',
];

export default routes;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/stepLearningGoalsRoutes.js